import { Search } from "lucide-react";

/**
 * Standardised search input with leading magnifier icon. The icon is absolutely
 * positioned so it never overlaps the placeholder or typed text (input has 36px
 * left padding, icon ends at ~28px). Drop-in replacement for the half-dozen
 * one-off implementations scattered across the admin pages.
 *
 * Usage:
 *   <SearchInput
 *     value={q}
 *     onChange={setQ}
 *     placeholder="Search orders…"
 *     onEnter={() => fetch()}
 *     data-testid="orders-search"
 *   />
 */
const SearchInput = ({
  value,
  onChange,
  placeholder = "Search…",
  onEnter,
  className = "",
  size = "md",
  ...rest
}) => {
  const h = size === "sm" ? "h-9" : "h-10";
  const iconSize = size === "sm" ? "h-3.5 w-3.5" : "h-4 w-4";
  return (
    <div className={`relative ${className}`}>
      <Search className={`absolute left-3 top-1/2 -translate-y-1/2 ${iconSize} text-neutral-400 pointer-events-none`} />
      <input
        type="search"
        value={value}
        onChange={(e) => onChange?.(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter" && onEnter) onEnter();
        }}
        placeholder={placeholder}
        className={`pav-input !pl-10 pr-3 ${h} w-full`}
        {...rest}
      />
    </div>
  );
};

export default SearchInput;
